
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/educational",
      function () {
        return require("private-next-pages/educational.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/educational"])
      });
    }
  